import React from 'react';

const ReconciliationView = () => (
    <div className="fin-placeholder">
        <h3 className="fin-placeholder-title">Monthly reconciliation — Phase 2</h3>
        <p className="fin-placeholder-sub">
            When the monthly Stripe invoice posts, pull it in and reconcile:
            actual per-tier % vs the MTD estimates, allocate overhead (Adaptive Acceptance,
            Radar, 3DS, disputes) proportionally across transactions, lock the month,
            surface variance between estimated and actual.
            <br /><br />
            Automate via Stripe <code>invoice.finalized</code> webhook in a later phase.
        </p>
    </div>
);

export default ReconciliationView;
